// The "···" menus are plain <details>, so they work without any of this. This
// only closes an open one when the member taps elsewhere, or leaves the page.
function closeMenus(except = null) {
  document.querySelectorAll("details.more[open]").forEach((menu) => {
    if (menu !== except) menu.removeAttribute("open")
  })
}

document.addEventListener("click", (event) => closeMenus(event.target.closest("details.more")))
document.addEventListener("keydown", (event) => { if (event.key === "Escape") closeMenus() })
document.addEventListener("turbo:before-cache", () => closeMenus())
